// extracted by mini-css-extract-plugin
module.exports = {"holder":"landingPage_holder__3G_gd","land":"landingPage_land__ucwRU","link":"landingPage_link__ldhq-","button":"landingPage_button__3tnu1","divi":"landingPage_divi__2pnnx"};